export default __webpack_public_path__ + "static/media/twitter.906b7998.png";